// extracted by css-extract-rspack-plugin
export default {"root":"src-wab-client-plasmic-plasmic_kit_design_system-PlasmicOverlayArrow-module__root-OYnGjQ","svg":"src-wab-client-plasmic-plasmic_kit_design_system-PlasmicOverlayArrow-module__svg-fPXSfR","svgdark":"src-wab-client-plasmic-plasmic_kit_design_system-PlasmicOverlayArrow-module__svgdark-sa9uwa"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"root\":\"src-wab-client-plasmic-plasmic_kit_design_system-PlasmicOverlayArrow-module__root-OYnGjQ\",\"svg\":\"src-wab-client-plasmic-plasmic_kit_design_system-PlasmicOverlayArrow-module__svg-fPXSfR\",\"svgdark\":\"src-wab-client-plasmic-plasmic_kit_design_system-PlasmicOverlayArrow-module__svgdark-sa9uwa\"}";
        // 1791313080955
        var cssReload = require("../../../../../../node_modules/.pnpm/@rspack+core@1.7.12_@swc+helpers@0.5.23/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  